export const ProjectKey = {
  ToneFlood: 'toneflood',
  ToneLowFlow: 'tonelowflow',
  Fukuoka: 'fukuoka',
  Nagano: 'nagano',
  Oita: 'oita',
} as const;

export type ProjectKey = (typeof ProjectKey)[keyof typeof ProjectKey];
